module.exports = __webpack_public_path__ + "files/b5cf382327bcef074107d758501f2ebb.png";